import React from 'react'
import useUpload from '../../hooks/upload/useUpload';

const ButtonDownload = ({ children, filename }) => {
  const { srcFile } = useUpload();
  return (
    <a href={srcFile(filename)} download target='_blank' rel='noreferrer'>
      {children}
    </a>
  )
}

export default ButtonDownload